import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import JalaaliUtils from '@date-io/jalaali';
// import './helpers/Firebase';
import ColorSwitcher from './components/common/ColorSwitcher';
import NotificationContainer from './components/common/react-notifications/NotificationContainer';
import ModalContainer from './components/modal/ModalContainer';
import { isMultiColorActive } from './constants/defaultValues';

import { getDirection } from './helpers/Utils';
import i18n from './services/i18n';
import jMoment from 'moment-jalaali';

jMoment.loadPersian({
  dialect: 'persian-modern',
  usePersianDigits: true,
});

const Main = React.lazy(() => import('./views'));
const Appp = React.lazy(() => import('./views/app'));
const User = React.lazy(() => import('./views/user'));
const Error = React.lazy(() => import('./views/error'));

const AuthRoute = ({ component: Component, isLoggedIn, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isLoggedIn) {
        localStorage.clear();
      }
      return isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/user/login',
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);

class App extends Component {
  constructor(props) {
    super(props);

    const { locale } = props;
    i18n.changeLanguage(locale);
  }

  componentWillMount() {
    // document.title = 'هسته مدیریت جامع پزشکت';
    const direction = getDirection();
    if (direction.isRtl) {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }

  render() {
    const { isLoggedIn } = this.props;

    return (
      <div className="h-100">
        <MuiPickersUtilsProvider utils={JalaaliUtils}>
          <React.Fragment>
            <NotificationContainer />
            <ModalContainer />
            {isMultiColorActive && <ColorSwitcher />}
            <Router>
              <React.Suspense fallback={<div className="loading" />}>
                <Switch>
                  <AuthRoute
                    path="/app"
                    isLoggedIn={isLoggedIn}
                    component={Appp}
                  />
                  <Route path="/user" component={User} />
                  <Route path="/error" exact component={Error} />
                  <Route path="/" exact component={Main} />
                  <Redirect to="/error" />
                </Switch>
              </React.Suspense>
            </Router>
          </React.Fragment>
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}

const mapStateToProps = ({ authUser, settings }) => {
  const { isLoggedIn } = authUser;
  const { locale } = settings;
  return { isLoggedIn, locale };
};

export default connect(mapStateToProps)(App);
